import { render, staticRenderFns } from "./bankSetBrazil.vue?vue&type=template&id=03f477f4&scoped=true"
import script from "./bankSetBrazil.vue?vue&type=script&lang=js"
export * from "./bankSetBrazil.vue?vue&type=script&lang=js"
import style0 from "./bankSetBrazil.vue?vue&type=style&index=0&id=03f477f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f477f4",
  null
  
)

export default component.exports